import { render } from "./search.vue?vue&type=template&id=766b5cf6&scoped=true"
import script from "./search.vue?vue&type=script&lang=js"
export * from "./search.vue?vue&type=script&lang=js"

import "./search.vue?vue&type=style&index=0&id=766b5cf6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-766b5cf6"]])

export default __exports__